import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { CheckCircleOutlineIcon } from '../../icons/CheckCircleOutlineIcon.js';
import { DangerIcon } from '../../icons/DangerIcon.js';
import { SuccessIcon } from '../../icons/SuccessIcon.js';
import styles from './Toast.module.scss.js';

var Toast = function (_a) {
    var _b;
    var title = _a.title, actionText = _a.actionText, children = _a.children, className = _a.className, style = _a.style, variant = _a.variant, onClose = _a.onClose;
    return (jsxs("div", __assign({ role: "alert", "aria-live": "assertive", "aria-atomic": "true", className: clsx(styles.toast, (_b = {},
            _b[styles.toastError] = variant === 'error',
            _b[styles.toastConfirmation] = variant === 'confirmation',
            _b), className), style: style }, { children: [jsxs("div", __assign({ className: styles.toastIcon }, { children: [variant === 'info' && jsx(SuccessIcon, {}), variant === 'confirmation' && jsx(CheckCircleOutlineIcon, {}), variant === 'error' && jsx(DangerIcon, {})] })), jsxs("div", { children: [jsx("div", __assign({ className: styles.toastTitle }, { children: title })), jsx("div", __assign({ className: styles.toastContent }, { children: children }))] }), jsx("button", __assign({ type: "button", className: styles.toastCloseButton, "aria-label": "close", onClick: onClose }, { children: actionText || 'Dismiss' }))] })));
};

export { Toast };
